<div>
  @if (shouldShowButton) {
    <app-dropdown-button
      [label]="buttonLabel"
      buttonClass="analytics-export-btn"
      icon="export"
      [options]="exportOptions"
      [disabled]="isExporting"
      (optionSelected)="onExportOptionSelected($event)"
    >
    </app-dropdown-button>
  } @else {
    <app-info-popover [text]="'ANALYTICS.EXPORT_NOT_AVAILABLE' | translate" />
  }
</div>
